import axios from 'axios';
import { updateUrlGetParams } from '@/helpers/url';
import { dayListMapping } from '@/helpers/settings';
import WebApi from '../WebApi';
class SettingsWebApi extends WebApi {
    async getSettingsRoles(payload) {
        const urlParams = `?pagination[per_page]=${payload.per_page}&pagination[page]=${payload.current_page}`;
        return axios.get(`${this.urlPrefix}/roles${urlParams}`, {
            data: {},
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    ;
    async getSettingsRoleNames() {
        const { data } = await axios.get(`${this.urlPrefix}/front_helpers/role_names`, {
            data: {},
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return data.role_name;
    }
    ;
    async getSettingsSelectors() {
        const { data } = await axios.get(`${this.urlPrefix}/components/ac_selectors`);
        return data;
    }
    ;
    async getSettingsRole(roleObj) {
        return axios.get(`${this.urlPrefix}/roles/${roleObj.id}`, {
            data: {},
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    ;
    async addSettingsRole(role, name) {
        return axios.post(`${this.urlPrefix}/roles`, {
            role: {
                ...role,
                ...{ name },
            },
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    ;
    async updateSettingsRole(role, name, id) {
        return axios.put(`${this.urlPrefix}/roles/${id}`, { role: {
                ...role,
                ...{ name },
            } }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    ;
    async deleteSettingsRole(role) {
        return axios.delete(`${this.urlPrefix}/roles/${role.id}`, {
            data: {},
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    ;
    async sentCalendarSettingsSlot(payload) {
        const calendar_view_setting = {};
        for (let i = 0; i < dayListMapping.length; i++) {
            const day = dayListMapping[i];
            // @ts-ignore-next-line
            calendar_view_setting[day] = payload[day];
            // @ts-ignore-next-line
            calendar_view_setting[`${day}_time_start`] = payload.timeFrom;
            // @ts-ignore-next-line
            calendar_view_setting[`${day}_time_end`] = payload.timeTo;
        }
        return axios.put(`${this.urlPrefix}/calendar_view_settings/${payload.calendar_view_setting_id}`, { calendar_view_setting }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    async getCompanySettingsData(id) {
        return axios.get(`${this.urlPrefix}/accounts/${id}`, {
            data: {},
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    ;
    async changeCompanySettingsData(account, accountId) {
        return axios.put(`${this.urlPrefix}/accounts/${accountId}`, { account }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    async getAppointmentTypes({ per_page, page, search, isArchive }) {
        const urlPostfix = isArchive ? `appointment_categories/archived` : `appointment_categories`;
        const url = updateUrlGetParams(`${this.urlPrefix}/${urlPostfix}`, {
            'pagination[per_page]': per_page,
            'pagination[page]': page,
            ...(search && { search }),
        });
        const { data } = await axios.get(decodeURI(url));
        return data;
    }
    async createAppointmentCategory(payload) {
        const { data } = await axios.post(`${this.urlPrefix}/appointment_categories`, payload);
        return data;
    }
    async editAppointmentType(payload, id) {
        const { data } = await axios.put(`${this.urlPrefix}/appointment_categories/${id}`, payload);
        return data;
    }
    async deleteAppointmentType(id) {
        const { data } = await axios.delete(`${this.urlPrefix}/appointment_categories/${id}`);
        return data;
    }
    async getManagers(payload) {
        const url = updateUrlGetParams(`${this.urlPrefix}/users`, {
            'pagination[per_page]': payload.per_page,
            'pagination[page]': payload.current_page,
            'scope': 'manager',
            ...(payload.search && { detail: payload.search }),
            ...(payload.sort && { sort: payload.sort }),
        });
        return await axios.get(decodeURI(url));
    }
    async getManagersList(payload) {
        const url = updateUrlGetParams(`${this.urlPrefix}/managers`, {
            'pagination[per_page]': payload.per_page,
            'pagination[page]': payload.current_page,
            ...(payload.search && { last_name: payload.search }),
            ...(payload.sort && { sort: payload.sort }),
        });
        return await axios.get(decodeURI(url));
    }
    async getAppointmentAdvancedSearch(payload) {
        const { location_skills, advisor_id, ...rest } = payload;
        const baseUrl = updateUrlGetParams(`${this.urlPrefix}/searches/appointment_categories`, rest);
        if (!Array.isArray(location_skills) || location_skills.length === 0) {
            const { data } = await axios.get(baseUrl);
            return data;
        }
        const url = new URL(baseUrl);
        location_skills.forEach((v) => {
            if (v !== null)
                url.searchParams.append('location_skills[]', String(v));
        });
        if (advisor_id !== null && advisor_id !== undefined) {
            url.searchParams.append('advisor_id', String(advisor_id));
        }
        const { data } = await axios.get(decodeURIComponent(url.toString()));
        return data;
    }
    async getManager(id) {
        const { data } = await axios.get(`${this.urlPrefix}/managers/${id}`);
        return data.manager;
    }
    async getCalendarViewData() {
        const { data } = await axios.get(`${this.urlPrefix}/calendar_view_settings`);
        return data;
    }
    async getAppointmentsNotifications() {
        const { data } = await axios.get(`${this.urlPrefix}/appointment_notifications`);
        return data.appointment_notifications;
    }
    async updateAppointmentsNotification(id, payload) {
        const { data } = await axios.put(`${this.urlPrefix}/appointment_notifications/${id}`, { appointment_notification: payload });
        return data.appointment_notification;
    }
    async createManager(manager) {
        const { data } = await axios.post(`${this.urlPrefix}/managers`, { manager });
        return data.manager;
    }
    async editManager(manager, id) {
        const { data } = await axios.put(`${this.urlPrefix}/managers/${id}`, { manager });
        return data.manager;
    }
    async deleteManager(id) {
        const { data } = await axios.delete(`${this.urlPrefix}/managers/${id}`);
        return data;
    }
    async getGenericUrlsSelectors() {
        const { data } = await axios.get(`${this.urlPrefix}/components/generic_url_selectors`);
        return data;
    }
    async getGenericUrls(payload, searchValue) {
        const urlParams = `?pagination[per_page]=${payload.per_page}&pagination[page]=${payload.current_page}${searchValue}`;
        const { data } = await axios.get(`${this.urlPrefix}/generic_urls${urlParams}`);
        return data;
    }
    async getKipRecipients() {
        const { data } = await axios.get(`${this.urlPrefix}/account_kpis_recipients`);
        return data.kpis_recipients || [];
    }
    async postKipRecipients(kpis_recipients) {
        const { data } = await axios.post(`${this.urlPrefix}/account_kpis_recipients`, { kpis_recipients });
        return data.kpis_recipients || [];
    }
    async getEmailTemplates({ kind, page, per_page, }) {
        const url = updateUrlGetParams(`${this.urlPrefix}/email_templates`, {
            'pagination[per_page]': per_page,
            'pagination[page]': page,
            ...(kind && { kind }),
        });
        const { data } = await axios.get(decodeURI(url));
        return data;
    }
    async getEmailTemplate(id) {
        const { data } = await axios.get(`${this.urlPrefix}/email_templates/${id}`);
        return data.email_template || data;
    }
    async updateEmailTemplate(id, payload) {
        const { data } = await axios.put(`${this.urlPrefix}/email_templates/${id}`, payload);
        return data.email_template || data;
    }
    async resetEmailTemplate(id) {
        const { data } = await axios.post(`${this.urlPrefix}/email_templates/${id}/reset`);
        return data.email_template || data;
    }
    async sendEmailTemplatePreview(id, previewers) {
        const { data } = await axios.post(`${this.urlPrefix}/email_templates/${id}/preview`, {
            email_template: { previewers },
        });
        return data;
    }
}
const settingsWebApi = new SettingsWebApi();
export { settingsWebApi as SettingsWebApi, };
